import { RemarkButton } from '@Components/IconButton';
import Remark from '@Components/Remark';
import { useDisclosure } from '@hooks/useDisclosure';
import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';
import { useGreenhouseForm } from '../../EsgGreenhouseFormProvider';
import { IGreenhouseStrategyFormValues } from '../../EsgGreenhouseFormProvider/types';

export const GH_STRATEGY_PLAN_REMARK_ID = 'gh-strategy-plan-remark';

const GreenhouseStrategyPlanRemark = () => {
  const { control, getValues } = useGreenhouseForm();
  const { remark } =
    getValues(`greenhouseStrategy.plan`) ??
    ({} as IGreenhouseStrategyFormValues);

  const [isRemarkOpen, { open, close }] = useDisclosure(!!remark);

  const ghGoalTermRemarkEl = document.getElementById(
    GH_STRATEGY_PLAN_REMARK_ID
  );

  const { completedSection } =
    useWatch({
      name: 'greenhouseStrategy',
      control,
    }) ?? ({} as IGreenhouseStrategyFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isRemarkOpen &&
        ghGoalTermRemarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              onDelete={close}
              topic="แผนการจัดการก๊าซเรือนกระจก"
              setOpen={open}
              fieldPath="greenhouseStrategy.plan.remark"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          ghGoalTermRemarkEl
        )}
    </>
  );
};

export default GreenhouseStrategyPlanRemark;
